import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import mixpanelEvents from '@Mixpanel';
import { setSubTopicFlags } from '@Actions/filterActions';
import { MultiSelectDropdown } from '@Components/UI/Dropdowns';
import { FilterDiv, InBodyTitle } from '../ScoreCardFilters.style';

const SubTopicsFilter = () => {
    const dispatch = useDispatch();

    const subTopicFlagsInput = useSelector(state => state.scoreCardFilters.subTopicFlagsInput);

    return (
        <FilterDiv>
            <InBodyTitle>Filter sub-topics</InBodyTitle>
            <MultiSelectDropdown
                name="sub-topics"
                searchBox
                options={subTopicFlagsInput}
                setOptions={input => {
                    dispatch(setSubTopicFlags(input));
                    mixpanelEvents.scorecardFiltersApplied();
                }}
            />
        </FilterDiv>
    );
};

export default SubTopicsFilter;
